import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {Spinner} from '../../Spinner';
import {ClientEconomicsApi} from '../../../api/clientEconomicsApi';
import {
    callbackErrorKey,
    escalafyRedirectUri,
    setPendingEscalafyConnection,
} from '../../client/economia/state/escalafyModel';

/**
 * Manda a Escalafy desde Conexiones (alta o reconexión). Es el MISMO auth-url de la agencia que usa
 * Economía, no el `get_auth_url/` genérico de Google: el backend arma la URL con PKCE y guarda el
 * `code_verifier`. La nota va sin cliente, así que el callback vuelve a Conexiones.
 *
 * Resuelve `{ok: false, response}` si el backend no dio la URL (sin módulo, conector sin configurar).
 */
export function startEscalafyAgencyOAuth({label = null, reconnectCredentialId = null} = {}) {
    return ClientEconomicsApi.escalafyAuthUrl(escalafyRedirectUri(), reconnectCredentialId).then((response) => {
        const url = response && response.status === 'OK' && response.data && response.data.url;
        if (!url) return {ok: false, response};
        setPendingEscalafyConnection({label});
        window.location.assign(url);
        return {ok: true, response};
    });
}

/** La clave del aviso cuando no se pudo ir a Escalafy. */
export function escalafyConnectErrorKey(response) {
    if (response && response.http_status === 503) return 'economics.escalafy.error.not_configured';
    return callbackErrorKey(response);
}

/** El botón del modal «Nueva conexión» para Escalafy: lleva el nombre tipeado en la nota del OAuth. */
export function EscalafyConnectButton({label = null}) {
    const {t} = useTranslation();
    const [busy, setBusy] = useState(false);

    const connect = () => {
        if (busy) return;
        setBusy(true);
        const failed = (response = null) => {
            setBusy(false);
            toast.error(t(escalafyConnectErrorKey(response)));
        };
        startEscalafyAgencyOAuth({label}).then((result) => {
            if (!result.ok) failed(result.response);
        }).catch(() => failed());
    };

    return (
        <button type="button" className="btn -alt escalafy-connect-btn" onClick={connect} disabled={busy}
                aria-busy={busy || undefined} data-testid="escalafy-connect-agency">
            {busy && <Spinner color="negative very-small"/>}
            {t('agency_connections.escalafy_connect')}
        </button>
    );
}

export default EscalafyConnectButton;
